
<template>
  <el-dialog class="dialog-change-tags" title="批量更新权限/价格" :visible="visible" @update:visible="setVisible" width="550px">
    <ConfigForms ref="form" :form-items="formItems"></ConfigForms>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">取 消</el-button>
      <el-button type="primary" size="small" @click="sure">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ConfigForms from '@/components/config-forms/index.vue'
import { videoPermissionTypes } from '../../../../config';

export default {
  name: 'DialogSetPrice',
  emits: ['submit'],
  components: { ConfigForms },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formItems: [
        { label: '观看权限', type: 'select', key: 'permission', options: videoPermissionTypes },
        { label: '价格', type: 'number', key: 'price' }
      ]
    };
  },
  mounted() {
    
  },

  methods: {
    setVisible(visible) {
      this.$emit('update:visible', visible)
    },
    close() {
      this.setVisible(false)
    },
    async sure() {
      try {
        const r = await this.$refs.form.validate()
        const output = Object.assign({}, r)
        for (const key in output) {
          const val = output[key]
          if (val === undefined || val === null || val === '') {
            delete output[key]
          } else if (Array.isArray(val) && val.length === 0) {
            delete output[key]
          }
        }
        this.$emit('submit', output)
      } catch (error) {
        console.error(error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>